import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Facebook } from "lucide-react";

const FloatingChat = () => {
  const [open, setOpen] = useState(false);
  const [showZaloQR, setShowZaloQR] = useState(false);

  const channels = [
    {
      name: "Messenger",
      icon: <Facebook size={18} />,
      link: "https://m.me/tiffanyhuongnghiep",
      color: "bg-darkbg border border-navy text-navy",
    },
    // {
    //   name: "Zalo",
    //   type: "zalo",
    //   icon: (
    //     <img
    //       src="https://upload.wikimedia.org/wikipedia/commons/9/91/Icon_of_Zalo.svg"
    //       alt="zalo"
    //       className="w-4 h-4"
    //     />
    //   ),
    //   color: "bg-[#0068FF] text-white",
    // },
  ];

  return (
    <>
      <div className="fixed bottom-10 right-6 z-[9999] flex flex-col items-end gap-3">
        {/* CHAT OPTIONS */}
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.9 }}
              className="flex flex-col gap-3 mb-2"
            >
              {channels.map((item, i) => {
                // 🔥 ZALO BUTTON
                if (item.type === "zalo") {
                  return (
                    <motion.button
                      key={i}
                      onClick={() => setShowZaloQR(true)}
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: i * 0.05 }}
                      className={`
                        flex items-center gap-3 px-4 py-3 rounded-full shadow-lg
                        ${item.color}
                        hover:scale-105 transition-all duration-200
                      `}
                    >
                      {item.icon}
                      <span className="text-sm font-medium">{item.name}</span>
                    </motion.button>
                  );
                }

                // 🔥 NORMAL LINK
                return (
                  <motion.a
                    key={i}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.05 }}
                    className={`
                      flex items-center gap-3 px-4 py-3 rounded-full shadow-lg
                      ${item.color}
                      hover:scale-105 transition-all duration-200
                    `}
                  >
                    {item.icon}
                    <span className="text-sm font-medium">{item.name}</span>
                  </motion.a>
                );
              })}
            </motion.div>
          )}
        </AnimatePresence>

        {/* MAIN BUTTON */}
        <motion.button
          onClick={() => setOpen(!open)}
          whileTap={{ scale: 0.9 }}
          className="
            w-14 h-14 rounded-full shadow-xl
            bg-navy text-white flex items-center justify-center
            hover:bg-yellow-600 transition-all duration-300
          "
        >
          {open ? <X size={22} /> : <MessageCircle size={22} />}
        </motion.button>
      </div>

      {/* 🔥 ZALO QR MODAL */}
      <AnimatePresence>
        {showZaloQR && (
          <motion.div
            className="fixed inset-0 z-[99999] bg-black/60 flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              className="bg-white rounded-2xl p-6 text-center shadow-xl max-w-sm w-full"
            >
              <h3 className="text-lg font-semibold mb-2">Chat on Zalo</h3>

              <p className="text-sm text-gray-500 mb-4">
                Open Zalo and scan this QR code
              </p>

              <img
                src="/zalo/trambuiQR.jpg"
                alt="Zalo QR"
                className="w-48  mx-auto rounded-lg border"
              />

              <button
                onClick={() => setShowZaloQR(false)}
                className="mt-4 px-4 py-2 bg-navy text-white rounded-full"
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingChat;
